import React, {useEffect, useState} from "react";
import { Routes, Route } from 'react-router-dom';

import OpenKitchenList from './customer/kitchen/OpenKitchenList';
import CreateOrderPage from './customer/Order/CreateOrderPage';
import UserProfilePage from "./UserProfile/UserProfilePage";
import Login from "./Login/Login";
import RegisterUser from "./Register/RegisterUser";
import ResetPassword from "./Login/ResetPassword";

// mui
import Divider from '@mui/material/Divider';
import { Typography, Box } from '@mui/material';

import { useUser } from "../UserContext";
import PageNavigator from "./PageNavigator";
import KitchenDashboard from "./chef/Kitchen/KitchenDashboard";

import { Utils } from "../utils/utils";
import OrderOverview from "./shared/OrderOverview";
import PaymentBalance from "./chef/PaymentBalance/PaymentBalance";

export default function PageContent(props) {
    const { user } = useUser();

    function handleList(kitchenList) {
        props.onKitchenListRetrieval(kitchenList);
    }

    return (
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: 2, 
              margin: 2,
              marginTop: { xs: 0, lg: 0 },
              // Add bottom padding on mobile to account for fixed AppBar at bottom
              paddingBottom: { xs: user ? '64px' : 0, md: 0 }
            }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: 16, justifyContent: 'space-between', alignItems: 'center'}}>
                  <Typography variant="h5" color={'GrayText'}>{user ? 'Welcome, ' + user.firstName : ''}</Typography>
                  <div style={{ paddingTop: 24 }}>
                    <PageNavigator />
                  </div>
              </div>

            { user && <Divider /> }

                <Routes>
                    <Route
                        path="/"
                        element={Utils.isCustomer(user) ? <OpenKitchenList filteredLocations={props.filteredLocations} userCoords={props.userCoords} /> : Utils.isChef(user) ? <KitchenDashboard /> : <Login />}
                    />
                    <Route
                        path="/login"
                        element={<Login />}
                    />
                    <Route
                        path="/register"
                        element={<RegisterUser />}
                    />
                    <Route
                        path="/reset-password"
                        element={<ResetPassword />}
                    />
                    <Route
                        path="/list"
                        element={Utils.isCustomer(user) ? <OpenKitchenList onKitchenListRetrieval={handleList} filteredLocations={props.filteredLocations} userCoords={props.userCoords} /> : Utils.isChef(user) ? <KitchenDashboard /> : <Login />}
                    />
                    <Route
                        path="/kitchen/:kitchenSelected"
                        element={Utils.isCustomer(user) ? <CreateOrderPage /> : Utils.isChef(user) ? <KitchenDashboard /> : <Login />}
                    />
                    <Route
                        path="/profile"
                        element={user ? <UserProfilePage /> : <Login />}
                    />
                    <Route
                        path="/dashboard"
                        element={Utils.isChef(user) ? <KitchenDashboard /> : Utils.isCustomer(user) ? <OpenKitchenList /> : <Login />}
                    />
                    <Route
                        path="/orders"
                        element={user ? <OrderOverview /> : <Login />}
                    />
                    <Route 
                        path="*" 
                        element={Utils.isChef(user) ? <KitchenDashboard /> : Utils.isCustomer(user) ? <OpenKitchenList /> : <Login />}
                    />
                </Routes>
            </Box>
    );
}